// 
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import React, { Fragment } from 'react';
import menu from '../../configs/menu.json';
import { NavLink, useLocation } from 'react-router-dom';
import "./Navigation.scss";
import Cookies from 'universal-cookie';

import StoreIcon from '@mui/icons-material/Store';
import GroupIcon from '@mui/icons-material/Group';
import LockIcon from '@mui/icons-material/Lock';
import BalanceIcon from '@mui/icons-material/Balance';
import BugReportIcon from '@mui/icons-material/BugReport';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ConstructionIcon from '@mui/icons-material/Construction';
import PersonIcon from '@mui/icons-material/Person';
import PublicIcon from '@mui/icons-material/Public';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import SettingsIcon from '@mui/icons-material/Settings';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InventoryIcon from '@mui/icons-material/Inventory';
import StorageIcon from '@mui/icons-material/Storage';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LanguageIcon from '@mui/icons-material/Language';
import HandymanIcon from '@mui/icons-material/Handyman';
import ToysIcon from '@mui/icons-material/Toys';

// 
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const Navigation = ({ user }) => {

  let location = useLocation()
  const cookies = new Cookies();
  const userData = cookies.get('olwe_management_user') || {};

  // 
  // ─── TOGGLE ACCORDION ───────────────────────────────────────
  //
  const dropDownToggle = (obj) => {
    let accordion = obj.target.nextSibling;
    if (accordion.classList.contains('accordion-open')) {
      accordion.style.height = "0px"
    } else {
      const elementNumber = Array.from(accordion.children)
      accordion.style.height = `${(elementNumber.length * (19 + 10) + 16)}px`;
    }
    accordion.classList.toggle('accordion-open')
  }

  // 
  // ─── AJOUT DES ICONES NECESSAIRES ───────────────────────────────────────
  //
  const menuIcons = {
    'faStore': <StoreIcon className="menu-icon" />,
    'faUsers': <GroupIcon className="menu-icon" />,
    'faLockAlt': <LockIcon className="menu-icon" />,
    'faBalanceScaleRight': <BalanceIcon className="menu-icon" />,
    'faBug': <BugReportIcon className="menu-icon" />,
    'faBook': <MenuBookIcon className="menu-icon" />,
    'faTools': <ConstructionIcon className="menu-icon" />,
    'faUserAlien': <PersonIcon className="menu-icon" />,
    'faGlobe': <PublicIcon className="menu-icon" />,
    'faNewspaper': <NewspaperIcon className="menu-icon" />,
    'faCogs': <SettingsIcon className="menu-icon" />,
    'faFileChartLine': <SsidChartIcon className="menu-icon" />,
    'faLightbulb': <EmojiObjectsIcon className="menu-icon" />,
    'AccessTimeIcon': <AccessTimeIcon className="menu-icon" />,
    'InventoryIcon': <InventoryIcon className="menu-icon" />,
    'StorageIcon': <StorageIcon className="menu-icon" />,
    'LocalOfferIcon': <LocalOfferIcon className="menu-icon" />,
    'LanguageIcon': <LanguageIcon className="menu-icon" />,
    'HandymanIcon': <HandymanIcon className="menu-icon" />,
    'ToysIcon': <ToysIcon className="menu-icon" />
  }

  // 
  // ─── GENERATE MENU RECURSIVELY ───────────────────────────────────────
  //
  const generateMenu = (opt) => {
    return opt.data.map((value) => {

      if (value.online === false) return true

      if ((value.role && !value.role.includes(userData.role)) && value.hasOwnProperty('role')) return true

      return <Fragment key={value.label}>
        {
          // 
          // ─── SET THE CATEGORY TITLE ───────────────────────────────────────
          //
        }
        {value.title ? (
          <>
            {value.label && <div>{value.label}</div>}
            <ul>
              {generateMenu({ data: value.children, path: [...opt.path, value.label] })}
            </ul>
          </>
        ) : (
          // 
          // ─── SET THE NAVIGATION ELEMENTS ───────────────────────────────────────
          //
          <li key={value.label}>
            {(value.hasOwnProperty('icon') && !value.hasOwnProperty('href')) ?
              <div onClick={(e) => { dropDownToggle(e) }} className={(location.pathname.includes(value.id) || (location.pathname === '/' && value.id === 'dashboard') ? 'active-menu' : '') + ' menu-parent'}>
                {menuIcons[value.icon]}
                <span>{value.label}</span>
                <ExpandMoreIcon className='expand_icon' />
              </div>
              : <NavLink to={value.href} exact="true" activeclassname="menu-link-selected" className={(!value.href ? "disable-link" : '') + ' ' + (value.hasOwnProperty('icon') ? 'menu-parent' : '') + ' ' + (location.pathname.includes(value.id) ? 'active-menu' : '')}>
                {menuIcons[value.icon]}
                <span>{value.label}</span>
              </NavLink>}

            {Boolean(value.children.length) && value.children.length && (
              <ul className='accordion'>
                {generateMenu({ data: value.children, path: [...opt.path, value.label], access_id: value.access_id })}
              </ul>
            )}
          </li>
        )
        }
      </Fragment >
    })
  }

  // 
  // ─── COMPONENT RENDER ───────────────────────────────────────
  // 
  return <nav>
    <svg viewBox="0 0 694 471" fill="none" xmlns="http://www.w3.org/2000/svg" className='logo'>
      <g clipPath="url(#clip0)">
        <path d="M471.636 223H593.604C598.224 223 600.996 220.228 600.996 215.608V189.12C600.996 184.5 598.224 181.728 593.604 181.728H509.52V30.192C509.52 25.572 506.748 22.8 502.128 22.8H471.636C467.016 22.8 464.244 25.572 464.244 30.192V215.608C464.244 220.228 467.016 223 471.636 223Z" fill="var(--text-color)" />
        <path d="M549.636 449H672.22C676.84 449 679.612 446.228 679.612 441.608V415.12C679.612 410.5 676.84 407.728 672.22 407.728H587.52V369.536H665.752C670.372 369.536 673.144 366.764 673.144 362.144V335.656C673.144 331.036 670.372 328.264 665.752 328.264H587.52V290.072H672.22C676.84 290.072 679.612 287.3 679.612 282.68V256.192C679.612 251.572 676.84 248.8 672.22 248.8H549.636C545.016 248.8 542.244 251.572 542.244 256.192V441.608C542.244 446.228 545.016 449 549.636 449Z" fill="var(--text-color)" />
        <path fillRule="evenodd" clipRule="evenodd" d="M12 123C12 178.228 56.7715 223 112 223C113.618 223 115.228 222.962 116.828 222.886C117.207 222.961 117.599 223 118 223L206 223C209.314 223 212 220.314 212 217L212 129C212 128.599 211.961 128.207 211.886 127.828C211.962 126.228 212 124.618 212 123C212 67.7715 167.228 23 112 23C56.7715 23 12 67.7715 12 123Z" fill="#FFB100" fillOpacity="0.7" />
        <path fillRule="evenodd" clipRule="evenodd" d="M112 449C167.228 449 212 404.228 212 349C212 347.382 211.962 345.772 211.886 344.172C211.961 343.793 212 343.401 212 343V255C212 251.686 209.314 249 206 249L118 249C117.599 249 117.207 249.039 116.828 249.114C115.228 249.038 113.618 249 112 249C56.7715 249 12 293.772 12 349C12 404.228 56.7715 449 112 449Z" fill="#F4D180" fillOpacity="0.4" />
        <path fillRule="evenodd" clipRule="evenodd" d="M338 223C393.228 223 438 178.228 438 123C438 67.7715 393.228 23 338 23C282.772 23 238 67.7715 238 123C238 124.618 238.038 126.228 238.114 127.828C238.039 128.207 238 128.599 238 129L238 217C238 220.314 240.686 223 244 223H332C332.401 223 332.793 222.961 333.172 222.886C334.772 222.962 336.382 223 338 223ZM338 178C368.376 178 393 153.376 393 123C393 92.6243 368.376 68 338 68C307.624 68 283 92.6243 283 123C283 153.376 307.624 178 338 178Z" fill="#FFB100" />
        <path d="M309.308 449H335.18C339.492 449 342.572 446.844 343.804 442.84L377.068 342.432L410.332 442.84C411.564 446.844 414.644 449 418.956 449H444.828C449.14 449 452.22 446.844 453.452 442.84L515.36 257.116C516.9 252.188 514.436 248.8 509.2 248.8H476.552C472.24 248.8 469.16 250.956 467.928 254.96L432.816 360.912L397.088 254.96C395.856 250.956 392.776 248.8 388.464 248.8H368.136C363.824 248.8 361.052 250.956 359.82 254.96L322.86 366.764L285.9 254.96C284.668 250.956 281.896 248.8 277.584 248.8H244.936C239.7 248.8 237.236 252.188 238.776 257.116L300.684 442.84C301.916 446.844 304.996 449 309.308 449Z" fill="var(--text-color)" />
      </g>
    </svg>
    <div className="user-card">
      <img src={`/assets/img/team/${userData.firstname.toLowerCase()}.jpg`} alt="" />
      <div className='user-infos'>
        <div>
          <span>{userData.firstname}</span>
          <span>{userData.name}</span>
        </div>
        <span>{userData.job}</span>
      </div>
    </div>
    <div className='menu-version'>
      <span><span>Api</span> : version  <span className="menu-version__number">3.0</span></span>
      <span><span>Application</span> : version   <span className="menu-version__number">3.0</span></span>
    </div>
    <div className="menu-container">
      {generateMenu({ data: menu, path: [] })}
    </div>
  </nav >
};

export default Navigation;